import React from "react";
import { banState, updateBanStatus } from "service/exam";
import { Button } from "antd";
import PopConfirm from "../../../components/PopConfirm";
import useRequestFn from "utils/useRequestFn";
import { ResultMessage } from "components/ResultMessage";
import { errorMessage } from "service/service";
import styles from "./index.module.scss";

interface ButtonBanProps {
    examId: string;
    stuNo: string;
    onOk(): void;
}

export function ButtonUndoBan({ examId, stuNo, onOk }: ButtonBanProps) {
    const [handleBan] = useRequestFn(async () => {
        try {
            await updateBanStatus(examId, banState.cancel, stuNo);
            onOk();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    });

    return (
        <PopConfirm
            title={
                <div style={{ width: 250 }}>
                    解除禁考成功后，该考生能打开试卷或提交试卷，确认解除禁考?
                </div>
            }
            onConfirm={handleBan}>
            <Button className={styles.button} type="link">
                解除禁考
            </Button>
        </PopConfirm>
    );
}
